export interface UIState {
	isPlaying: boolean;
	isLoading: boolean;
	error: string | null;
}

const CALL_TO_ACTION_PHRASES = [
	"🍑 Touch the butt",
	"💨 Let 'er rip",
	"👆 Tap that",
	"🫳 Press for gas",
	"👆 Go ahead, push it",
	"🤏 Give it a squeeze",
	"👉 Pull my finger",
	"💨 Release the pressure",
	"🍑 Boop the booty",
	"👆 Make some noise",
];

export class UIManager {
	private container: HTMLElement;
	private instructionsEl: HTMLElement | null = null;
	private errorEl: HTMLElement | null = null;
	private callToAction: string;

	constructor(container: HTMLElement) {
		this.container = container;
		this.callToAction =
			CALL_TO_ACTION_PHRASES[
				Math.floor(Math.random() * CALL_TO_ACTION_PHRASES.length)
			];
	}

	render(state: UIState) {
		// Clear existing elements
		this.instructionsEl?.remove();
		this.errorEl?.remove();
		this.instructionsEl = null;
		this.errorEl = null;

		// Render instructions
		if (!state.isLoading && !state.error && !state.isPlaying) {
			this.instructionsEl = document.createElement("div");
			this.instructionsEl.className = "instructions";

			const p = document.createElement("p");
			p.textContent = this.callToAction;

			this.instructionsEl.appendChild(p);
			this.container.appendChild(this.instructionsEl);
		}

		// Render error
		if (state.error) {
			this.errorEl = document.createElement("div");
			this.errorEl.className = "error";

			const p = document.createElement("p");
			p.textContent = `Error: ${state.error}`;

			this.errorEl.appendChild(p);
			this.container.appendChild(this.errorEl);
		}
	}

	destroy() {
		this.instructionsEl?.remove();
		this.errorEl?.remove();
	}
}
